/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum InsightContext {
  Level1 = "Level1",
  Level2 = "Level2",
  Article = "Article",
  Default = "Default",
}
